import { gql } from '@apollo/client';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  BROKER_ID_NAME_FIELDS,
  COUNTRY_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';

export const LEASE_SEARCH_RESULT_FIELDS = `
  id
  signDate
  type
  leaseType {
    ${ID_NAME_FIELDS}
  }
  country {
    ${COUNTRY_FIELDS}
  }
  size
  sizeMt
  measurementSystem
  floor
  rentType
  escalation
  escalationType
  escalationFormatted
  escalationIncrement
  tenantImprovementAllowance
  termInMonths
  freeRentMonths
  baseRent
  netEffectiveRentCustom
  currencyCode
  expirationDate
  taxAndOpex
  transactionType
  tenantCompany {
    ${ID_NAME_FIELDS}
  }
  tenantBrokers {
    ${BROKER_ID_NAME_FIELDS}
  }
  landlordBrokers {
    ${BROKER_ID_NAME_FIELDS}
  }
`;

export const LEASE_OPTION_FRAGMENT = gql`
  fragment leaseOption on LeaseOption {
    id
    leaseId
    optionTypeId
    optionDate
    optionNoticeDate
    breakOptionPenalty
    optionExecuted
    freeRent
    renewalTermInMonths
    expansionSf
    rollingBreak
  }
`;

export const LEASE_INFO_FRAGMENT = gql`
  fragment leaseInfo on Lease {
    id
    type
    expandingContracting {
      ${ID_NAME_FIELDS}
    }
    leaseType {
      ${ID_NAME_FIELDS}
    }
    signDate
    size
    sizeMt
    measurementSystem
    baseRent
    rentType
    escalation
    taxAndOpex
    commencementDate
    escalationType
    escalationFormatted
    escalationIncrement
    escalationIncrementType {
      ${ID_NAME_FIELDS}
    }
    freeRentMonths
    freeRentType {
      ${ID_NAME_FIELDS}
    }
    expirationDate
    currencyCode
    tenantImprovementAllowance
    termInMonths
    floor
    stories
    comments
    additionalConcessions
    additionalConcessionsPSF
    additionalConcessionsPSM
    transactionType
    leaseOptions {
      ...leaseOption
    }
    tenantCompany {
      ${ID_NAME_FIELDS}
      industry {
        ${ID_NAME_FIELDS}
      }
    }
    tenantBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
    landlordBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
    spaceUse {
      ${ID_NAME_FIELDS}
    }
    property {
      ${PROPERTY_MAIN_FIELDS}
      propertyCountry {
        ${COUNTRY_FIELDS}
      }
      propertyType {
        ${ID_NAME_FIELDS}
      }
      propertyClass {
        ${ID_NAME_FIELDS}
      }
      market {
        ${ID_NAME_FIELDS}
      }
      submarket {
        ${ID_NAME_FIELDS}
      }
      micromarket {
        ${ID_NAME_FIELDS}
      }
    }
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUserId
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
    createdAt
    updatedAt
  }
  ${LEASE_OPTION_FRAGMENT}
`;
